import { IconButton } from '@zep-us/zus';
import { ThumbDownFillIcon, ThumbDownIcon, ThumbUpFillIcon, ThumbUpIcon } from '@zep-us/zus-icons';
import { useAiBuilderChatActions } from '../store';
import { type AiBuilderResponseFeedbackTargetMessage, getNextAiBuilderResponseFeedback } from '../utils/aiBuilderResponseFeedback';
export const AiBuilderResponseFeedbackControls = ({
  message
}: {
  message: AiBuilderResponseFeedbackTargetMessage;
}) => {
  const {
    setResponseFeedback
  } = useAiBuilderChatActions();
  const controls = [{
    feedback: 'good' as const,
    icon: ThumbUpIcon,
    selectedIcon: ThumbUpFillIcon
  }, {
    feedback: 'bad' as const,
    icon: ThumbDownIcon,
    selectedIcon: ThumbDownFillIcon
  }];
  return <div className="flex items-center gap-4xs" data-sentry-component="AiBuilderResponseFeedbackControls" data-sentry-source-file="AiBuilderResponseFeedbackControls.tsx">
      {controls.map(control => {
      const selected = message.feedback === control.feedback;
      const FeedbackIcon = selected ? control.selectedIcon : control.icon;
      const nextFeedback = getNextAiBuilderResponseFeedback(message.feedback ?? null, control.feedback);
      return <IconButton key={control.feedback} type="button" variant="transparent" intent="neutral" size="sm" rounded="full" disabled={message.feedbackPending} aria-pressed={selected} data-ai-builder-response-feedback={control.feedback} onClick={() => setResponseFeedback(message.id, nextFeedback)}>
            <FeedbackIcon size="xs" aria-hidden="true" />
          </IconButton>;
    })}
    </div>;
};